module.exports = __webpack_public_path__ + "img/spider-arranged-categories-fr.71a266cc.png";